import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useEffect, useRef, useState } from 'react';
import findFatura from '../../service/findFatura';
import { SortOrder } from 'primereact/api';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import { Dropdown } from 'primereact/dropdown';
import React from 'react';
import findClient from '../../service/findClient';
import { Toolbar } from 'primereact/toolbar';
import findFaturamento from '../../service/findFaturamento';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import getFaturaDownload from '../../service/getFaturaDownload';
import getFaturaDownloadRegistro from '../../service/getFaturaDownloadRegistro';
import getFaturaDownloadConsulta from '../../service/getFaturaDownloadConsulta';
import gerarNotaFiscalFatura from '../../service/gerarNotaFiscalFatura';
import gerarPdfFatura from '../../service/gerarPdfFatura';
import patchCancelarBoletoFaturaService from '../../service/patchCancelarBoletoFatura';
import patchFaturaIncobravelService from '../../service/patchFaturaIncobravel';
import patchFaturaManualGerarService from '../../service/patchFaturaManualGerar';
import { Nullable } from 'primereact/ts-helpers';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { Editor } from 'primereact/editor';
import { Toast } from 'primereact/toast';
import { Menu } from 'primereact/menu';
import { formatarParaMoedaBRL } from '../../utils';
import postFaturaAdministrarService from '../../service/postFaturaAdministrar';
import postFaturaManualService from '../../service/postFaturaManual';
import postFaturaEnviarEmailService from '../../service/postFaturaEnviarEmail';
import getFaturaFaturamentoService from '../../service/getFaturaFaturamento';
import putFaturaRegistrarPagamentoService from '../../service/putFaturaRegistrarPagamento';
import patchClientStatus from '../../service/patchClientStatus';

// Cor e ícone de cada status da fatura, usados nos cards e no badge da tabela.
const FATURA_STATUS_CONFIG: Record<string, { color: string; icon: string }> = {
  PREPARACAO: { color: 'var(--blue-500, #3b82f6)', icon: 'pi pi-clock' },
  GERANDO_BOLETO: { color: 'var(--blue-500, #3b82f6)', icon: 'pi pi-cog' },
  BOLETO_GERADO: { color: 'var(--blue-500, #3b82f6)', icon: 'pi pi-file' },
  PDF_GERADO: { color: 'var(--blue-500, #3b82f6)', icon: 'pi pi-file' },
  RECEBIVEL: { color: 'var(--teal-500, #14b8a6)', icon: 'pi pi-wallet' },
  VENCIDO: { color: 'var(--red-500, #ef4444)', icon: 'pi pi-exclamation-triangle' },
  PAGO: { color: 'var(--green-500, #22c55e)', icon: 'pi pi-check-circle' },
  INCOBRAVEL: { color: 'var(--purple-500, #a855f7)', icon: 'pi pi-ban' },
};
const FATURA_TOTAL_CONFIG = { color: 'var(--bluegray-500, #64748b)', icon: 'pi pi-chart-bar' };

const TIPO_FATURA_MANUAL_OPTIONS = [
  { label: 'Nota fiscal e Boleto', value: 'NOTA_FISCAL_BOLETO' },
  { label: 'Nota fiscal', value: 'NOTA_FISCAL' },
  { label: 'Boleto', value: 'BOLETO' },
];
const getFaturaStatusConfig = (status: string) =>
  status === 'undefined' ? FATURA_TOTAL_CONFIG
    : (FATURA_STATUS_CONFIG[status] ?? { color: 'var(--orange-500, #f97316)', icon: 'pi pi-question-circle' });

export default function FaturaPage() {
  const { t } = useTranslation();
  const [faturas, setFaturas] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const [expandedRows, setExpandedRows] = useState(undefined);
  const {state} = useGlobalState();
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [clients, setClients] = useState<any>([]);
  const [selectedFaturamento, setSelectedFaturamento] = useState<any>(null);
  const [faturamentos, setFaturamentos] = useState<any>([]);
  const [counts, setCounts] = useState([]);
  const toast = useRef<Toast>(null);
  const menuAcoes = useRef<Menu>(null);
  const [menuItems, setMenuItems] = useState<any[]>([]);
  const [status, setStatus] = useState<Nullable<String | null>>(null);
  const [registrarPagamentoVisible, setRegistrarPagamentoVisible] = useState(false);
  const [faturaBaixaManual, setFaturaBaixaManual] = useState<any>(null);
  const [valorPago, setValorPago] = useState<number | null>(null);
  const [dataPagamento, setDataPagamento] = useState<Date | null>(null);
  const [descontoVisible, setDescontoVisible] = useState(false);
  const [faturaDesconto, setFaturaDesconto] = useState<any>(null);
  const [valorDesconto, setValorDesconto] = useState<number | null>(null);
  const [descricaoDesconto, setDescricaoDesconto] = useState<string>('');
  const [isDesconto, setIsDesconto] = useState<boolean>(true);
  const [cancelarBoletoVisible, setCancelarBoletoVisible] = useState(false);
  const [faturaCancelarBoleto, setFaturaCancelarBoleto] = useState<any>(null);
  const [incobravelVisible, setIncobravelVisible] = useState(false);
  const [faturaIncobravel, setFaturaIncobravel] = useState<any>(null);
  const [emailVisible, setEmailVisible] = useState(false);
  const [faturaEmail, setFaturaEmail] = useState<any>(null);
  const [emailDestino, setEmailDestino] = useState<string>('');
  const [assuntoEmail, setAssuntoEmail] = useState<string>('');
  const [textoEmail, setTextoEmail] = useState<string>('');
  const [faturaManualVisible, setFaturaManualVisible] = useState(false);
  const [clienteFaturaManual, setClienteFaturaManual] = useState<any>(null);
  const [faturamentoFaturaManual, setFaturamentoFaturaManual] = useState<any>(null);
  const [tipoFaturaManual, setTipoFaturaManual] = useState<string | null>(null);
  const [itensFaturaManual, setItensFaturaManual] = useState<any[]>([]);
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    faturamento: selectedFaturamento ? selectedFaturamento.code : null,
    cliente: selectedClient ? selectedClient.code : null,
    status: status,
    sortField: 'cliente.nome',
    sortOrder: SortOrder.ASC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      faturamento: selectedFaturamento ? selectedFaturamento.code : null,
      cliente: selectedClient ? selectedClient.code : null,
      status: status,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const onSort = (event:any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      faturamento: selectedFaturamento ? selectedFaturamento.code : null,
      cliente: selectedClient ? selectedClient.code : null,
      status: status,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const rowExpansionTemplate = (data:any) => {
    
    return (
        <div>
            <h5>Itens Fatura</h5>
            <DataTable value={data.itens}>
                <Column field="servico" header={t('servico')} sortable></Column>
                <Column field="quantidade" header={t('quantidade')} sortable></Column>
                <Column field="valor" header={t('valor')} sortable></Column>
                <Column field="total" header={t('total')} sortable></Column>
            </DataTable>
        </div>
    );
  };

  const loadLazyData = () => {
    findFatura(lazyState).then(data => {setTotalRecords(data.total);setCounts(data.resumos);setFaturas(data.faturas)}).catch(() => {setTotalRecords(0);setCounts([]);setFaturas(undefined)});
  }

  const changeCliente = (value:any) => {
    setSelectedClient(value);
    setlazyState({
      first: 0,
    rows: 10,
    page: 1,
    faturamento: selectedFaturamento ? selectedFaturamento.code : null,
    cliente: value ? value.code : null,
    status: status, 
    sortField: 'cliente.nome',
    sortOrder: SortOrder.ASC
    });
  };

  const changeFaturamento = (value:any) => {
    setSelectedFaturamento(value);
    setlazyState({
      first: 0,
    rows: 10,
    page: 1,
    faturamento: value ? value.code : null,
    cliente: selectedClient ? selectedClient.code : null,
    status: status, 
    sortField: 'cliente.nome',
    sortOrder: SortOrder.ASC
    });
  };

  const startContent = (
    <div className="filtros">
      <div className="filtros-grid">
        <div className="filtros-item">
          <label htmlFor="faturamento" className="font-bold">{t("faturamento")}</label>
          <Dropdown inputId="faturamento" value={selectedFaturamento} onChange={(e) => { changeFaturamento(e.value) }} options={faturamentos} optionLabel="name" placeholder="Selecione Faturamento" filter />
        </div>
        {!state.user.cliente && (
          <div className="filtros-item">
            <label htmlFor="cliente" className="font-bold">{t("cliente")}</label>
            <Dropdown inputId="cliente" value={selectedClient} onChange={(e) => { changeCliente(e.value) }} options={clients} optionLabel="name" placeholder="Selecione Cliente" showClear filter />
          </div>
        )}
      </div>
    </div>
  );

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
  };

  useEffect(() => {
    if(!state.user.cliente){
      const lazyClient = {
        first: 0,
        rows: 99999999,
        page: 1,
        cliente: 'null',
        documento: 'null',
        codigo : 'null',
        inativo: null,
        sortField: 'nome',
        sortOrder: SortOrder.DESC
      }
      const clientes : any[] = [];
      
      findClient(lazyClient).then(data => {
        data.clientes.forEach( (c: { nome: string; id: string; }) => {
          clientes.push({name: c.nome, code:c.id})
        })
      })
      setClients(clientes);
    }

    const lazyFaturamento = {
      first: 0,
      rows: 20,
      page: 1,
      data: null,
      status: null,
      sortField: 'dataReferencia',
      sortOrder: SortOrder.DESC
    }
    const faturamentos : any[] = [];
    
    findFaturamento(lazyFaturamento).then(data => {
      data.faturamentos.forEach( (c: { dataReferencia: Date; id: string; }) => {
        faturamentos.push({name: formatDate(c.dataReferencia), code:c.id})
      })
      setSelectedFaturamento(faturamentos[0])
      changeFaturamento(faturamentos[0])
    })
    setFaturamentos(faturamentos);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const clienteTemplate = (item: any) => {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
        {item.cliente}
        {item.observacaoInconsistencia && (
          <i
            className="pi pi-exclamation-triangle"
            style={{ color: '#f59e0b', cursor: 'help' }}
            title={'Pendências na apuração da fatura de cancelamento:\n\n' + item.observacaoInconsistencia}
          />
        )}
      </span>
    );
  }

  const statusTemplate = (item: any) => {
      if(item.vencimento && item.status === 'PDF_GERADO'){
        const [dia, mes, ano] = String(item.vencimento).split('/').map(Number);
        const vencimento = new Date(ano, mes - 1, dia);
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        if(vencimento < hoje){
          item.status = 'VENCIDO';
          item.label = 'Vencido';
        }
        else{
          item.status = 'RECEBIVEL';
          item.label = 'Recebível';
        }
      }
      const cfg = getFaturaStatusConfig(item.status);
      return (
        <span className="status-pill" style={{ backgroundColor: cfg.color, color: '#ffffff' }}>
          <i className={cfg.icon}></i>
          {item.label}
        </span>
      );
    }

  const downloadFatura = (fatura: any) => {
    getFaturaDownload(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "octet/stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fatura.pdf`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);
    });
  };

  const downloadFaturaRegistro = (fatura: any) => {
    getFaturaDownloadRegistro(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "octet/stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fatura_registro.pdf`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);
    });
  };

  const isFaturaBaixaManualElegivel = (fatura: any) => {
    const statusFatura = fatura.statusFatura;
    if (statusFatura === 'VENCIDO' || statusFatura === 'RECEBIVEL') {
      return true;
    }
    if (statusFatura === 'PDF_GERADO' && fatura.dataVencimento) {
      return true;
    }
    return false;
  };

  const parseValor = (valor: any): number | null => {
    if (valor === null || valor === undefined || valor === '') return null;
    if (typeof valor === 'number') return isNaN(valor) ? null : valor;
    const normalizado = String(valor).replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
    const numero = parseFloat(normalizado);
    return isNaN(numero) ? null : numero;
  };

  const abrirDialogoBaixaManual = (fatura: any) => {
    setFaturaBaixaManual(fatura);
    setValorPago(parseValor(fatura.valor));
    setDataPagamento(new Date());
    setRegistrarPagamentoVisible(true);
  };

  const fecharDialogoBaixaManual = () => {
    setRegistrarPagamentoVisible(false);
    setFaturaBaixaManual(null);
    setValorPago(null);
    setDataPagamento(null);
  };

  const confirmarBaixaManual = () => {
    if (!faturaBaixaManual || valorPago === null || !dataPagamento) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Informe valor pago e data de pagamento',
        life: 4000
      });
      return;
    }
    putFaturaRegistrarPagamentoService({
      id: faturaBaixaManual.id,
      valorPago: valorPago,
      dataPagamento: dataPagamento
    })
      .then(() => {
        toast.current?.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Pagamento registrado com sucesso',
          life: 4000
        });
        fecharDialogoBaixaManual();
        loadLazyData();
      })
      .catch((error: any) => {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: error?.message || 'Erro ao registrar pagamento',
          life: 5000
        });
      });
  };

  const abrirDialogoDesconto = (fatura: any) => {
    setFaturaDesconto(fatura);
    setValorDesconto(null);
    setDescricaoDesconto('');
    setIsDesconto(true);
    setDescontoVisible(true);
  };

  const fecharDialogoDesconto = () => {
    setDescontoVisible(false);
    setFaturaDesconto(null);
    setValorDesconto(null);
    setDescricaoDesconto('');
    setIsDesconto(true);
  };

  const confirmarDesconto = () => {
    if (!faturaDesconto || valorDesconto === null || !descricaoDesconto.trim()) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Informe valor e descrição',
        life: 4000
      });
      return;
    }
    postFaturaAdministrarService({
      idFatura: faturaDesconto.id,
      valor: valorDesconto,
      descricao: descricaoDesconto,
      desconto: isDesconto
    })
      .then(() => {
        toast.current?.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: isDesconto ? 'Desconto aplicado com sucesso' : 'Acréscimo aplicado com sucesso',
          life: 4000
        });
        fecharDialogoDesconto();
        loadLazyData();
      })
      .catch((error: any) => {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: error?.message || 'Erro ao administrar fatura',
          life: 5000
        });
      });
  };

  const abrirDialogoCancelarBoleto = (fatura: any) => {
    setFaturaCancelarBoleto(fatura);
    setCancelarBoletoVisible(true);
  };

  const fecharDialogoCancelarBoleto = () => {
    setCancelarBoletoVisible(false);
    setFaturaCancelarBoleto(null);
  };

  const confirmarCancelarBoleto = () => {
    if (!faturaCancelarBoleto) {
      return;
    }
    patchCancelarBoletoFaturaService(faturaCancelarBoleto.id)
      .then(() => {
        toast.current?.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Boleto cancelado com sucesso',
          life: 4000
        });
        fecharDialogoCancelarBoleto();
        loadLazyData();
      })
      .catch((error: any) => {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: error?.message || 'Erro ao cancelar boleto',
          life: 5000
        });
      });
  };

  const abrirDialogoIncobravel = (fatura: any) => {
    setFaturaIncobravel(fatura);
    setIncobravelVisible(true);
  };

  const fecharDialogoIncobravel = () => {
    setIncobravelVisible(false);
    setFaturaIncobravel(null);
  };

  const confirmarIncobravel = () => {
    if (!faturaIncobravel) {
      return;
    }
    patchFaturaIncobravelService(faturaIncobravel.id)
      .then(() => {
        toast.current?.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Fatura marcada como incobrável',
          life: 4000
        });
        fecharDialogoIncobravel();
        loadLazyData();
      })
      .catch((error: any) => {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: error?.message || 'Erro ao marcar fatura como incobrável',
          life: 5000
        });
      });
  };

  const tagsEmail = [
    { tag: '#nomeCliente#', descricao: 'Nome do cliente' },
    { tag: '#valor#', descricao: 'Valor da fatura' },
    { tag: '#referencia#', descricao: 'Referência fatura' },
    { tag: '#vencimento#', descricao: 'Vencimento da fatura' }
  ];

  const copiarTagEmail = (tag: string) => {
    navigator.clipboard.writeText(tag);
    toast.current?.show({ severity: 'success', summary: 'Copiado', detail: `Tag ${tag} copiada!`, life: 2000 });
  };

  const abrirDialogoEmail = (fatura: any) => {
    setFaturaEmail(fatura);
    setEmailDestino(fatura.emailFatura || '');
    setAssuntoEmail('');
    setTextoEmail('');
    setEmailVisible(true);
    if (selectedFaturamento) {
      getFaturaFaturamentoService(fatura.id).then((data) => {
        setAssuntoEmail(data.assuntoEmail || '');
        setTextoEmail(data.textoEmail || '');
      }).catch((error: any) => {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: error?.message || 'Erro ao carregar assunto e texto do email',
          life: 5000
        });
      });
    }
  };

  const fecharDialogoEmail = () => {
    setEmailVisible(false);
    setFaturaEmail(null);
    setEmailDestino('');
    setAssuntoEmail('');
    setTextoEmail('');
  };

  const confirmarEnviarEmail = () => {
    if (!faturaEmail || !emailDestino.trim() || !assuntoEmail.trim() || !textoEmail.trim()) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Informe email, assunto e texto',
        life: 4000
      });
      return;
    }
    postFaturaEnviarEmailService({
      idFatura: faturaEmail.id,
      email: emailDestino,
      assunto: assuntoEmail,
      texto: textoEmail
    })
      .then(() => {
        toast.current?.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Email enviado com sucesso',
          life: 4000
        });
        fecharDialogoEmail();
      })
      .catch((error: any) => {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: error?.message || 'Erro ao enviar email',
          life: 5000
        });
      });
  };

  const processarFaturaManual = (fatura: any) => {
    patchFaturaManualGerarService(fatura.id)
      .then(() => {
        toast.current?.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Fatura processada com sucesso',
          life: 4000
        });
        loadLazyData();
      })
      .catch((error: any) => {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: error?.message || 'Erro ao processar fatura',
          life: 5000
        });
      });
  };

  const abrirDialogoFaturaManual = () => {
    setClienteFaturaManual(selectedClient);
    setFaturamentoFaturaManual(selectedFaturamento);
    setTipoFaturaManual(null);
    setItensFaturaManual([{ quantidade: 1, descricao: '', valorUnitario: null }]);
    setFaturaManualVisible(true);
  };

  const fecharDialogoFaturaManual = () => {
    setFaturaManualVisible(false);
    setClienteFaturaManual(null);
    setFaturamentoFaturaManual(null);
    setTipoFaturaManual(null);
    setItensFaturaManual([]);
  };

  const adicionarItemFaturaManual = () => {
    setItensFaturaManual([...itensFaturaManual, { quantidade: 1, descricao: '', valorUnitario: null }]);
  };

  const removerItemFaturaManual = (index: number) => {
    setItensFaturaManual(itensFaturaManual.filter((_, i) => i !== index));
  };

  const alterarItemFaturaManual = (index: number, campo: string, valor: any) => {
    setItensFaturaManual(itensFaturaManual.map((item, i) => (i === index ? { ...item, [campo]: valor } : item)));
  };

  const confirmarFaturaManual = () => {
    const itensValidos = itensFaturaManual.length > 0 &&
      itensFaturaManual.every((item) => item.quantidade > 0 && item.descricao.trim() && item.valorUnitario !== null);
    if (!clienteFaturaManual || !faturamentoFaturaManual || !tipoFaturaManual || !itensValidos) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Informe cliente, faturamento, tipo e preencha todos os itens',
        life: 4000
      });
      return;
    }
    postFaturaManualService({
      idCliente: clienteFaturaManual.code,
      idFaturamento: faturamentoFaturaManual.code,
      tipoFaturaManual: tipoFaturaManual,
      itens: itensFaturaManual.map((item) => ({
        quantidade: item.quantidade,
        descricao: item.descricao,
        valorUnitario: item.valorUnitario
      }))
    })
      .then(() => {
        toast.current?.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Fatura manual criada com sucesso',
          life: 4000
        });
        fecharDialogoFaturaManual();
        loadLazyData();
      })
      .catch((error: any) => {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: error?.message || 'Erro ao criar fatura manual',
          life: 5000
        });
      });
  };

  const downloadNotaFiscal = (fatura: any) => {
    gerarNotaFiscalFatura(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `nota_fiscal_${fatura.id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const gerarPdf = (fatura: any) => {
    gerarPdfFatura(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `boleto_${fatura.id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const changeStatus = (status: Nullable<any>) => {
    status = status ? status : null
    if (status instanceof Object) {
      status = null
    }
    setStatus(status);
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      faturamento: selectedFaturamento ? selectedFaturamento.code : null,
      cliente: selectedClient ? selectedClient.code : null,
      status: status,
      sortField: 'cliente.nome',
      sortOrder: SortOrder.ASC
    });

  }

  const downloadFaturaConsulta= (fatura: any) => {
    getFaturaDownloadConsulta(fatura.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "octet/stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fatura_consulta.pdf`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);
    });
  };

  const buildAcoesFatura = (fatura: any) => {
    const items: any[] = [];
    if (state.user.funcoes.includes("FATURA_IMPRIMIR")) {
      items.push({
        label: "Download Fatura",
        icon: "pi pi-file-pdf",
        command: () => downloadFatura(fatura),
      });
    }


    

    if (fatura.possuiRegistro) {
      items.push({
        label: "Registros da Fatura",
        icon: "pi pi-id-card",
        command: () => downloadFaturaRegistro(fatura),
      });
    }

    if (fatura.possuiConsulta) {
      items.push({
        label: "Consultas da Fatura",
        icon: "pi pi-search",
        command: () => downloadFaturaConsulta(fatura),
      });
    }

    if (state.user.funcoes.includes("FATURA_PDF") && fatura.linhaDigitavel) {
      items.push({
        label: "Download Boleto",
        icon: "pi pi-download",
        command: () => gerarPdf(fatura),
      });
    }

    if (state.user.funcoes.includes("FATURA_GERAR_NOTA_FISCAL") && fatura.possuiNotaFiscal) {
      items.push({
        label: "Download Nota Fiscal",
        icon: "pi pi-file",
        command: () => downloadNotaFiscal(fatura),
      });
    }

    if (state.user.funcoes.includes("FATURA_REGISTRAR_PAGAMENTO") && isFaturaBaixaManualElegivel(fatura)) {
      items.push({
        label: "Registrar pagamento",
        icon: "pi pi-check-square",
        command: () => abrirDialogoBaixaManual(fatura),
      });
    }

    if (state.user.funcoes.includes("FATURA_ADMINISTRAR") && fatura.statusFatura === 'PREPARACAO') {
      items.push({
        label: "Administrar fatura",
        icon: "pi pi-percentage",
        command: () => abrirDialogoDesconto(fatura),
      });
    }

    if (state.user.funcoes.includes("FATURA_ADMINISTRAR") && fatura.statusFatura === 'PREPARACAO' && fatura.tipoFaturaManual != null) {
      items.push({
        label: "Processar fatura",
        icon: "pi pi-cog",
        command: () => processarFaturaManual(fatura),
      });
    }

    if (state.user.funcoes.includes("FATURA_BOLETO_CANCELAR") && fatura.statusFatura === 'PDF_GERADO') {
      items.push({
        label: "Cancelar Boleto e Nota Fiscal",
        icon: "pi pi-ban",
        command: () => abrirDialogoCancelarBoleto(fatura),
      });
    }

    if (state.user.funcoes.includes("FATURA_ENVIAR_EMAIL") && fatura.statusFatura === 'PDF_GERADO' && (fatura.possuiNotaFiscal || fatura.linhaDigitavel)) {
      items.push({
        label: "Enviar Email",
        icon: "pi pi-envelope",
        command: () => abrirDialogoEmail(fatura),
      });
    }

    if (state.user.funcoes.includes("FATURA_ADMINISTRAR") && (fatura.statusFatura === 'PREPARACAO' || fatura.statusFatura === 'GERANDO_BOLETO')) {
      items.push({
        label: "Marcar como Incobrável",
        icon: "pi pi-times-circle",
        command: () => abrirDialogoIncobravel(fatura),
      });
    }

    if (state.user.funcoes.includes("FATURA_ANALISE_CLIENTE")) {
      items.push({
        separator: true,
      });
      items.push({
        label: "Análise Financeira do Cliente",
        icon: "pi pi-chart-bar",
        command: () => window.open(`/creditbureau/fatura/saude-financeira/${fatura.id}`, '_blank'),
      });
    }

    if (state.user.funcoes.includes("CLIENTE_CADASTRAR") && fatura.idCliente) {
      items.push({
        label: fatura.clienteInativo ? "Ativar Cliente" : "Inativar Cliente",
        icon: fatura.clienteInativo ? "pi pi-check-circle" : "pi pi-pause-circle",
        command: () => toggleStatusCliente(fatura),
      });
    }

    return items;
  };

  const toggleStatusCliente = (fatura: any) => {
    const novoStatus = !fatura.clienteInativo;
    patchClientStatus(fatura.idCliente, novoStatus)
      .then(() => {
        toast.current?.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: `Cliente ${novoStatus ? 'inativado' : 'ativado'} com sucesso`,
          life: 3000,
        });
        loadLazyData();
      })
      .catch(() => toast.current?.show({ severity: 'error', summary: 'Erro', detail: 'Falha ao alterar status do cliente', life: 5000 }));
  };

  const actionTemplate = (fatura: any) => {
    const acoes = buildAcoesFatura(fatura);
    if (acoes.length === 0) {
      return null;
    }

    return (
      <Button
        icon="pi pi-ellipsis-v"
        tooltip="Ações"
        aria-label="Ações"
        onClick={(e) => {
          setMenuItems(acoes);
          menuAcoes.current?.toggle(e);
        }}
        style={{
          background: "transparent",
          color: "gray",
          border: "none",
        }}
      />
    );
  };


  useEffect(() => {
    if(lazyState.faturamento){
      loadLazyData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[lazyState])

  return (
    <Container>
      <Toast ref={toast} />
      <Menu model={menuItems} popup ref={menuAcoes} />
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-dollar" style={{ fontSize: '2.0rem' }}></i> {t('faturas')}</h1>
            </div>     
          </div>
      </div>
      <div className="card">
       <Toolbar start={startContent} end={state.user.funcoes.includes("FATURA_CADASTRAR") && (
         <Button label="Criar Fatura Manual" icon="pi pi-plus" style={{ backgroundColor: '#183462' }} onClick={abrirDialogoFaturaManual} />
       )} />
        <br></br>
        <br></br>
        <div className="status-cards status-cards--fill">
          {counts.map((item: any, index: number) => {
            const cfg = getFaturaStatusConfig(item.status);
            const isTotal = item.status === 'undefined';
            const selected = !!status && status === item.status;
            const dimmed = !!status && status !== item.status;
            return (
              <Card
                key={index}
                style={{ cursor: 'pointer', borderTop: `4px solid ${cfg.color}` }}
                className={'status-card' + (dimmed ? ' disabled' : '') + (selected ? ' status-card--selected' : '')}
                onClick={() => changeStatus(!isTotal ? item.status : null)}
              >
                <div className="status-card__head">
                  <span className="status-card__icon" style={{ backgroundColor: cfg.color }}>
                    <i className={cfg.icon} />
                  </span>
                  {selected && (
                    <Button
                      icon="pi pi-times"
                      text
                      className="button_remove_backgroung status-card__clear"
                      onClick={(e) => { e.stopPropagation(); changeStatus(null) }}
                      style={{ color: 'rgb(24, 52, 98)' }}
                      aria-label="Limpar filtro"
                    />
                  )}
                </div>
                <span className="status-card__label">{item.label}</span>
                <span className="status-card__total">{item.value}</span>
                <span className="status-card__value">R$ {item.total}</span>
              </Card>
            );
          })}
        </div>
        <br></br>
        <DataTable value={faturas} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros" expandedRows={expandedRows} onRowToggle={(e:any) => setExpandedRows(e.data)}
                        rowExpansionTemplate={rowExpansionTemplate}
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           <Column expander={true} style={{ width: '1.5rem' }} />              
           <Column sortable sortField='cliente.nome' header={t('cliente')} body={clienteTemplate}  />
           <Column field="dataReferencia" sortable header={t('dataReferencia')}  />
           <Column field="dataVencimento" sortable header={t('dataVencimento')}  />
           <Column field="valorMinimo" sortable header={t('vcm')}  /> 
           <Column field="valorConsumo" sortable header={t('valorConsumo')}  /> 
           <Column field="valorComplementar" sortable header={t('valorComplementar')}  /> 
           <Column field="valor" sortable header={t('valor')}  /> 
           <Column body={(item) => item.dataPagamento ? formatDate(new Date(item.dataPagamento)) : ''} sortable sortField="dataPagamento" header={t('dataPagamento')}  />
           <Column field="valorPagamento" body={(item) => item.valorPagamento ? formatarParaMoedaBRL(item.valorPagamento) : ''} sortable sortField="valorPagamento" header={t('valorPagamento')}  />
           <Column body={(item) => statusTemplate({status:item.statusFatura, label: item.statusFaturaLabel, vencimento: item.dataVencimento})} sortable sortField="statusFatura" header={t('status')}  /> 
           <Column style={{width: '11%'}} body={actionTemplate} />
        </DataTable> 
      </div>
      <Dialog
        visible={registrarPagamentoVisible}
        header="Registrar Pagamento"
        modal
        style={{ width: '420px' }}
        onHide={fecharDialogoBaixaManual}
        footer={
          <React.Fragment>
            <Button label="Fechar" severity="secondary" outlined onClick={fecharDialogoBaixaManual} />
            <Button style={{backgroundColor: '#183462' }} label="Confirmar" onClick={confirmarBaixaManual} />
          </React.Fragment>
        }
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="valorPago" className="font-bold block mb-2">{t('valorPagamento')}</label>
            <InputNumber
              id="valorPago"
              value={valorPago}
              onValueChange={(e) => setValorPago(e.value ?? null)}
              mode="currency"
              currency="BRL"
              locale="pt-BR"
              min={0}
            />
          </div>
          <div className="field">
            <label htmlFor="dataPagamento" className="font-bold block mb-2">{t('dataPagamento')}</label>
            <Calendar
              id="dataPagamento"
              value={dataPagamento}
              onChange={(e) => setDataPagamento((e.value as Date) ?? null)}
              dateFormat="dd/mm/yy"
              showIcon
              locale="pt"
            />
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={descontoVisible}
        header="Administrar Fatura"
        modal
        style={{ width: '420px' }}
        onHide={fecharDialogoDesconto}
        footer={
          <React.Fragment>
            <Button label="Fechar" severity="secondary" outlined onClick={fecharDialogoDesconto} />
            <Button style={{backgroundColor: '#183462' }} label="Confirmar" onClick={confirmarDesconto} />
          </React.Fragment>
        }
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="tipoOperacao" className="font-bold block mb-2">Tipo de operação</label>
            <Dropdown
              id="tipoOperacao"
              value={isDesconto}
              onChange={(e) => setIsDesconto(e.value)}
              options={[
                { label: 'Desconto (diminuir)', value: true },
                { label: 'Acréscimo (aumentar)', value: false }
              ]}
              optionLabel="label"
            />
          </div>
          <div className="field">
            <label htmlFor="valorDesconto" className="font-bold block mb-2">{isDesconto ? 'Valor do Desconto' : 'Valor do Acréscimo'}</label>
            <InputNumber
              id="valorDesconto"
              value={valorDesconto}
              onValueChange={(e) => setValorDesconto(e.value ?? null)}
              mode="currency"
              currency="BRL"
              locale="pt-BR"
              min={0}
            />
          </div>
          <div className="field">
            <label htmlFor="descricaoDesconto" className="font-bold block mb-2">Descrição</label>
            <InputTextarea
              id="descricaoDesconto"
              value={descricaoDesconto}
              onChange={(e) => setDescricaoDesconto(e.target.value)}
              rows={3}
              autoResize
            />
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={emailVisible}
        header="Enviar Email"
        modal
        style={{ width: '560px' }}
        onHide={fecharDialogoEmail}
        footer={
          <React.Fragment>
            <Button label="Fechar" severity="secondary" outlined onClick={fecharDialogoEmail} />
            <Button style={{ backgroundColor: '#183462' }} label="Enviar" onClick={confirmarEnviarEmail} />
          </React.Fragment>
        }
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="emailDestino" className="font-bold block mb-2">Email</label>
            <InputText
              id="emailDestino"
              value={emailDestino}
              onChange={(e) => setEmailDestino(e.target.value)}
              placeholder="destinatario@email.com"
            />
          </div>
          <div className="field">
            <label htmlFor="assuntoEmail" className="font-bold block mb-2">Assunto</label>
            <InputText
              id="assuntoEmail"
              value={assuntoEmail}
              onChange={(e) => setAssuntoEmail(e.target.value)}
            />
          </div>
          <div className="field">
            <label htmlFor="textoEmail" className="font-bold block mb-2">Texto</label>
            <Editor
              id="textoEmail"
              value={textoEmail}
              onTextChange={(e) => setTextoEmail(e.htmlValue || '')}
              style={{ height: '260px' }}
            />
          </div>
          <div className="field">
            <div style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '6px', padding: '0.75rem 1rem', marginTop: '0.5rem' }}>
              <span style={{ fontWeight: 600, fontSize: '0.85rem', color: '#495057', display: 'block', marginBottom: '0.4rem' }}>
                <i className="pi pi-info-circle" style={{ marginRight: '0.4rem' }} />Tags disponíveis (clique para copiar):
              </span>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                {tagsEmail.map((tg) => (
                  <span
                    key={tg.tag}
                    onClick={() => copiarTagEmail(tg.tag)}
                    style={{ backgroundColor: '#e3f2fd', borderRadius: '4px', padding: '0.25rem 0.6rem', fontSize: '0.8rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.3rem', transition: 'background-color 0.2s' }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#bbdefb')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#e3f2fd')}
                  >
                    <i className="pi pi-copy" style={{ fontSize: '0.7rem' }} />
                    <b>{tg.tag}</b> {tg.descricao}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={cancelarBoletoVisible}
        header="Cancelar Boleto"
        modal
        style={{ width: '420px' }}
        onHide={fecharDialogoCancelarBoleto}
        footer={
          <React.Fragment>
            <Button label="Não" severity="secondary" outlined onClick={fecharDialogoCancelarBoleto} />
            <Button style={{ backgroundColor: '#d32f2f' }} label="Sim, cancelar" onClick={confirmarCancelarBoleto} />
          </React.Fragment>
        }
      >
        {faturaCancelarBoleto && (
          <div>
            <p>Tem certeza que deseja cancelar o boleto desta fatura?</p>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li className="mb-2"><strong>Cliente:</strong> {faturaCancelarBoleto.cliente}</li>
              <li className="mb-2"><strong>Número:</strong> {faturaCancelarBoleto.numero || faturaCancelarBoleto.id}</li>
              <li className="mb-2"><strong>Valor:</strong> R$ {faturaCancelarBoleto.valor}</li>
            </ul>
          </div>
        )}
      </Dialog>
      <Dialog
        visible={incobravelVisible}
        header="Marcar como Incobrável"
        modal
        style={{ width: '420px' }}
        onHide={fecharDialogoIncobravel}
        footer={
          <React.Fragment>
            <Button label="Não" severity="secondary" outlined onClick={fecharDialogoIncobravel} />
            <Button style={{ backgroundColor: '#d32f2f' }} label="Sim, marcar" onClick={confirmarIncobravel} />
          </React.Fragment>
        }
      >
        {faturaIncobravel && (
          <div>
            <p>Tem certeza que deseja marcar esta fatura como incobrável?</p>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li className="mb-2"><strong>Cliente:</strong> {faturaIncobravel.cliente}</li>
              <li className="mb-2"><strong>Número:</strong> {faturaIncobravel.numero || faturaIncobravel.id}</li>
              <li className="mb-2"><strong>Valor:</strong> R$ {faturaIncobravel.valor}</li>
            </ul>
          </div>
        )}
      </Dialog>
      <Dialog
        visible={faturaManualVisible}
        header="Criar Fatura Manual"
        modal
        style={{ width: '640px' }}
        onHide={fecharDialogoFaturaManual}
        footer={
          <React.Fragment>
            <Button label="Fechar" severity="secondary" outlined onClick={fecharDialogoFaturaManual} />
            <Button style={{ backgroundColor: '#183462' }} label="Confirmar" onClick={confirmarFaturaManual} />
          </React.Fragment>
        }
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="clienteFaturaManual" className="font-bold block mb-2">{t('cliente')}</label>
            <Dropdown
              id="clienteFaturaManual"
              value={clienteFaturaManual}
              onChange={(e) => setClienteFaturaManual(e.value)}
              options={clients}
              optionLabel="name"
              placeholder="Selecione Cliente"
              filter
            />
          </div>
          <div className="field">
            <label htmlFor="faturamentoFaturaManual" className="font-bold block mb-2">{t('faturamento')}</label>
            <Dropdown
              id="faturamentoFaturaManual"
              value={faturamentoFaturaManual}
              onChange={(e) => setFaturamentoFaturaManual(e.value)}
              options={faturamentos}
              optionLabel="name"
              placeholder="Selecione Faturamento"
              filter
            />
          </div>
          <div className="field">
            <label htmlFor="tipoFaturaManual" className="font-bold block mb-2">Tipo</label>
            <Dropdown
              id="tipoFaturaManual"
              value={tipoFaturaManual}
              onChange={(e) => setTipoFaturaManual(e.value)}
              options={TIPO_FATURA_MANUAL_OPTIONS}
              optionLabel="label"
              placeholder="Selecione o Tipo"
            />
          </div>
          <div className="field">
            <label className="font-bold block mb-2">Itens</label>
            {itensFaturaManual.map((item, index) => (
              <div key={index} style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', marginBottom: '0.5rem' }}>
                <InputText
                  value={item.descricao}
                  onChange={(e) => alterarItemFaturaManual(index, 'descricao', e.target.value)}
                  placeholder="Descrição"
                  style={{ flex: 1 }}
                />
                <InputNumber
                  value={item.quantidade}
                  onValueChange={(e) => alterarItemFaturaManual(index, 'quantidade', e.value ?? null)}
                  min={1}
                  placeholder="Qtde"
                  style={{ width: '55px', flex: '0 0 auto' }}
                  inputStyle={{ width: '55px' }}
                />
                <InputNumber
                  value={item.valorUnitario}
                  onValueChange={(e) => alterarItemFaturaManual(index, 'valorUnitario', e.value ?? null)}
                  mode="currency"
                  currency="BRL"
                  locale="pt-BR"
                  min={0}
                  placeholder="Valor unitário"
                  style={{ width: '130px', flex: '0 0 auto' }}
                  inputStyle={{ width: '130px' }}
                />
                <Button
                  icon="pi pi-trash"
                  type="button"
                  onClick={() => removerItemFaturaManual(index)}
                  disabled={itensFaturaManual.length === 1}
                  aria-label="Remover item"
                  style={{ background: 'transparent', color: 'red', border: 'none', width: 'auto', flex: '0 0 auto' }}
                />
              </div>
            ))}
            <Button
              label="Adicionar item"
              icon="pi pi-plus"
              text
              onClick={adicionarItemFaturaManual}
              style={{ width: 'auto', color: '#183462' }}
            />
          </div>
        </div>
      </Dialog>
    </Container>
  )
}
